// Single "Pro" plan, four billing periods. Numbers are the source of truth for
// the marketing UI; the Worker maps each period -> a Stripe price ID.
export type Period = "mo" | "1y" | "2y" | "3y";

export interface PlanInfo {
  perMo: number;
  months: number;
  label: string;
  billed: string;
  sub: string;
  save: string;
}

export const PRICING: Record<Period, PlanInfo> = {
  mo: {
    perMo: 10,
    months: 1,
    label: "Monthly",
    billed: "€10 billed monthly",
    sub: "no commitment",
    save: "",
  },
  "1y": {
    perMo: 5,
    months: 12,
    label: "1 year",
    billed: "€60 billed yearly",
    sub: "€5/mo · billed yearly",
    save: "save 50%",
  },
  "2y": {
    perMo: 4,
    months: 24,
    label: "2 years",
    billed: "€96 billed every 2 years",
    sub: "€4/mo · billed up front",
    save: "save 60%",
  },
  "3y": {
    perMo: 3,
    months: 36,
    label: "3 years",
    billed: "€108 billed every 3 years",
    sub: "€3/mo · billed up front",
    save: "save 70%",
  },
};

export const PERIOD_ORDER: Period[] = ["mo", "1y", "2y", "3y"];
export const DEFAULT_PERIOD: Period = "2y";

export const planTotal = (p: Period) => PRICING[p].perMo * PRICING[p].months;
